import React from 'react'
import styled from 'styled-components'
import Section from '@/components/Section'
import Container from '@/components/Container'

import media from 'styled-media-query'
import treat from '../../../images/treat.svg'
import TaxonomyHeader from '@/components/TaxonomyHeader'
import TaxonomyHeading from '@/components/TaxonomyHeading'
import TaxonomySubSection from '@/components/TaxonomySubSection'
import TaxonomySubSectionHeading from '@/components/TaxonomySubSectionHeading'
import TaxonomyBadges from '@/components/TaxonomyBadges'
import { mapTaxonomyToRoute } from '../../../domain/useCases/taxonomyBadges/matchTreatmentToRoute'
import { CareOptions } from './CareOptions'
import { createPrimaryFocusMap } from '@/domain/term/useCases/createPrimaryFocusMap'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isNonEmptyArray } from '@/utils/checks'

const Style = styled.div`
  hr {
    margin-top: 40px;
    width: 100%;
    background: ${(props) => props.theme.tan};
    height: 1px;
    border: none;
    ${media.lessThan('medium')`

		`}
  }

  .treatment {
    margin-bottom: 10px;
    display: flex;
    padding-top: 30px;
  }

  .treatmentHeader {
    margin-bottom: 10px;
    display: flex;
    padding-top: 30px;
  }

  .button {
    cursor: pointer;
  }

  .items {
    position: relative;
    &-check {
      ul {
        margin-top: 0;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 10px;
        // justify-content: space-between;
        ${media.lessThan('medium')`
        columns: 1;

      `}
        padding-left: 0;
        li {
          margin-right: 8px;
          .noline {
            background: rgb(241, 244, 248);
            color: rgb(22, 41, 65);
            // padding: 5px 10px;
          }
          #space {
            background: rgb(241, 244, 248);
            color: rgb(22, 41, 65);
            // padding: 5px 10px;
          }
          &:nth-child(odd) {
            // width: 40%;
            ${media.lessThan('small')`
          // width: 100%;
          // margin-top: 8px;
        `}
          }
          &:nth-child(even) {
            // width: 60%;
            ${media.lessThan('small')`
            // width: 100%;
            // margin-top: 8px;
          `}
          }
          margin-left: 0;
          margin-top: 8px;
          list-style: none;
          & > div:first-child {
            // width: 20px;
          }
          & > div {
            // max-width: 200px;
            img {
              // display: inline;
              margin-right: 10px;
            }
            display: inline-flex;
            div {
              display: flex;
              align-items: center;
            }
            p {
              display: inline;
              vertical-align: super;
              margin-left: 0px;
              font-size: 16px;
            }
          }
        }
      }
    }
    &-chip {
      ul {
        padding-left: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        margin-top: 0;
        li {
          margin-top: 10px;
          margin-right: 10px;
          list-style: none;
          padding: 5px 10px;
          background: rgb(241, 244, 248);
          border-radius: 3px;
        }
      }
    }
  }
`
const DEFAULT_EMPTY_ARRAY = []

export default function Treatment({ data }) {
  const {
    new_specializations = DEFAULT_EMPTY_ARRAY,
    specializations = DEFAULT_EMPTY_ARRAY,
    therapies = DEFAULT_EMPTY_ARRAY,
    included_aftercare = DEFAULT_EMPTY_ARRAY,
    arranged_aftercare = DEFAULT_EMPTY_ARRAY,
    what_we_treat = DEFAULT_EMPTY_ARRAY,
    locations,
    _treatment_services = DEFAULT_EMPTY_ARRAY,
    _treatment_method = DEFAULT_EMPTY_ARRAY,
    is_standard,
    taxonomyList = {
      allTaxonomy: {
        edges: []
      }
    },
    primaryFocus
  } = data

  const treatmentServicesBadges = _treatment_services.filter(
    (item) => item?.title
  )

  const generateLinkFromTerm = (termTitle) => {
    const term = taxonomyList.allTaxonomy.edges.find(
      (term) => term.title.toLowerCase() === termTitle.toLowerCase()
    )
    return mapTaxonomyToRoute(term?.type, term?.slug)
  }

  const approachesBadges = _treatment_method.filter((item) => item?.title)

  /**
   * TODO: retire on of the fields and refactor this
   * https://linear.app/rehabpath/issue/COO-566/merge-new-specializations-and-specializations
   */
  const specializationsBadges = (specializations || new_specializations || [])
    .filter((item) => item?.title)
    .map((item) => {
      return {
        route: generateLinkFromTerm(item.title),
        ...item
      }
    })
  const therapiesBadges = therapies.filter((item) => item?.title)

  const primaryFocusMap = createPrimaryFocusMap()
  const whatWeTreatBadges = what_we_treat
    .filter((item) => item?.title)
    .map((item) => {
      return {
        ...item,
        primaryFocus: primaryFocusMap[item.title]
      }
    })
  const conditionsWeTreat = []
  const substancesWeTreat = []
  const whatWeTreatTitles = []

  whatWeTreatBadges.forEach((item) => {
    whatWeTreatTitles.push(item.title)
    if (item.primaryFocus === PrimaryFocus.SUBSTANCE_USE) {
      substancesWeTreat.push(item)
    } else {
      conditionsWeTreat.push(item)
    }
  })

  const afterCareBadges = [
    ...(arranged_aftercare || []),
    ...(included_aftercare || [])
  ]
    .filter((element, index, self) => {
      if (typeof element === 'string') return true
      return index === self?.findIndex((t) => t?.title === element?.title)
    })
    .map((element) =>
      typeof element === 'string' ? { title: element } : element
    )

  const LOCATION_WHITELIST = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Florida',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
    'Los Angeles',
    'Orange County',
    'San Diego',
    'Malibu',
    'Bay Area',
    'South Florida',
    'Palm Beach',
    'Miami',
    'Orlando',
    'Texas',
    'Austin',
    'Houston',
    'Dallas',
    'Europe',
    'New England',
    'Asia',
    'India',
    'Australia',
    'Canada',
    'South Africa',
    'United Kingdom'
  ]

  if (!data.whitelistedLocation) {
    for (let i = 0; i < locations?.length; i++) {
      if (LOCATION_WHITELIST.includes(locations[i])) {
        data.whitelistedLocation = locations[i].trim()
        break
      }
    }
  }

  const treatmentServices = _treatment_services
    .filter((item) => item?.title)
    .map((item) => item.title)

  const hasSpecializationsBadges = isNonEmptyArray(specializationsBadges)
  const hasTreatmentServicesBadges = isNonEmptyArray(treatmentServicesBadges)
  const hasApproachesBadges = isNonEmptyArray(approachesBadges)
  const hasTherapiesBadges = isNonEmptyArray(therapiesBadges)
  const hasConditionsWeTreat = isNonEmptyArray(conditionsWeTreat)
  const hasSubstancesWeTreat = isNonEmptyArray(substancesWeTreat)
  const hasAfterCareBadges = isNonEmptyArray(afterCareBadges)

  const showTreatmentBlock =
    hasSpecializationsBadges ||
    hasTreatmentServicesBadges ||
    hasApproachesBadges ||
    hasTherapiesBadges ||
    hasConditionsWeTreat ||
    hasSubstancesWeTreat ||
    hasAfterCareBadges

  return (
    <Style>
      {is_standard && (
        <>
          <Section>
            <Container>
              <CareOptions
                centerPrimaryFocus={primaryFocus}
                location={data.whitelistedLocation}
                treatmentServices={treatmentServices}
                whatWeTreat={whatWeTreatTitles}
              />
            </Container>
          </Section>

          <div className="border-t-1 mt-6 h-6 border-gray-200 md:mt-12 md:h-12" />
        </>
      )}

      {showTreatmentBlock && (
        <Section>
          <Container>
            <TaxonomyHeader>
              <img src={treat} />
              <TaxonomyHeading tag="h3">Treatment</TaxonomyHeading>
            </TaxonomyHeader>

            {hasSpecializationsBadges && (
              <TaxonomySubSection>
                <TaxonomySubSectionHeading text="Specializations" />
                <TaxonomyBadges
                  itemsList={specializationsBadges}
                  isStandard={is_standard}
                />
              </TaxonomySubSection>
            )}

            {!is_standard && hasTreatmentServicesBadges && (
              <TaxonomySubSection>
                <TaxonomySubSectionHeading text="Treatment Services" />
                <TaxonomyBadges itemsList={treatmentServicesBadges} />
              </TaxonomySubSection>
            )}

            {hasApproachesBadges && (
              <TaxonomySubSection>
                <TaxonomySubSectionHeading text="Approaches" />
                <TaxonomyBadges itemsList={approachesBadges} />
              </TaxonomySubSection>
            )}

            {hasTherapiesBadges && (
              <TaxonomySubSection>
                <TaxonomySubSectionHeading text="Therapies" />
                <TaxonomyBadges itemsList={therapiesBadges} />
              </TaxonomySubSection>
            )}

            <div>
              {hasConditionsWeTreat && (
                <TaxonomySubSection
                  className={
                    primaryFocus !== PrimaryFocus.SUBSTANCE_USE
                      ? 'order-1'
                      : 'order-2'
                  }
                >
                  <TaxonomySubSectionHeading text="Conditions We Treat" />
                  <TaxonomyBadges itemsList={conditionsWeTreat} />
                </TaxonomySubSection>
              )}

              {hasSubstancesWeTreat && (
                <TaxonomySubSection
                  className={
                    primaryFocus !== PrimaryFocus.SUBSTANCE_USE
                      ? 'order-2'
                      : 'order-1'
                  }
                >
                  <TaxonomySubSectionHeading text="Substances We Treat" />
                  <TaxonomyBadges itemsList={substancesWeTreat} />
                </TaxonomySubSection>
              )}
            </div>

            {hasAfterCareBadges && (
              <TaxonomySubSection>
                <TaxonomySubSectionHeading text="Aftercare" />
                <TaxonomyBadges itemsList={afterCareBadges} />
              </TaxonomySubSection>
            )}
          </Container>
        </Section>
      )}
    </Style>
  )
}
